import { useState } from "react";
import { useApplication } from "../contexts/ApplicationContext";
import {
  MdControlPointDuplicate,
  MdMonitorHeart,
  MdSupportAgent,
} from "react-icons/md";
import { FaMagnifyingGlass, FaTable } from "react-icons/fa6";
import AdminQueriesTable from "../components/tables/AdminQueriesTable";
import AdminTablesTable from "../components/tables/AdminTablesTable";
import AdminUsersTable from "../components/tables/AdminUsersTable";
import AdminProvidersTable from "../components/tables/AdminProvidersTable";
import AdminHelpCenterTable from "../components/tables/AdminHelpCenterTable";
import { IoMdPeople, IoMdPricetags } from "react-icons/io";
import { LiaSellsy } from "react-icons/lia";
import AdminRedudancyTable from "../components/tables/AdminRedudancyTable";
import SystemVariablesManagerPage from "./SystemVariablesManagerPage";
import { GiSettingsKnobs } from "react-icons/gi";
import VPSMonitorPage from "./VPSMonitorPage";
import RepresentativeTablePage from "./RepresentativeTablePage";

const AdminPage = () => {
  const { user, userPermission } = useApplication();
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      title: "Tabelas",
      icon: FaTable,
      content: <AdminTablesTable isActive={activeTab === 0} />,
    },
    {
      title: "Usuários",
      icon: IoMdPeople,
      content: <AdminUsersTable isActive={activeTab === 1} />,
    },
    {
      title: "Configuráveis",
      icon: GiSettingsKnobs,
      content: <SystemVariablesManagerPage isActive={true} />,
    },
  ];

  if (userPermission === "POWER_USER") {
    tabs.push(
      {
        title: "Consultas",
        icon: FaMagnifyingGlass,
        content: <AdminQueriesTable isActive={true} />,
      },
      {
        title: "Provedores",
        icon: LiaSellsy,
        content: <AdminProvidersTable isActive={true} />,
      },
      {
        title: "Suporte",
        icon: MdSupportAgent,
        content: <AdminHelpCenterTable isActive={true} />,
      },
      {
        title: "Redundância",
        icon: MdControlPointDuplicate,
        content: <AdminRedudancyTable isActive={true} />,
      },
      {
        title: "Monitoramento",
        icon: MdMonitorHeart,
        content: <VPSMonitorPage isActive={true} />,
      }
    );
  }

  return (
    <div className="bg-gradient-to-br from-white via-slate-50 to-white px-4 py-4 rounded-2xl shadow-lg shadow-slate-200/60 border border-slate-200/70 relative">
      <div
        className="flex items-center gap-2 overflow-x-auto pb-1.5 -mx-1 px-1"
        role="tablist"
        aria-label="Admin"
      >
        <div className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-white/80 p-1 shadow-sm">
          {tabs.map((tab, idx) => {
            const Icon = tab.icon;
            const isActive = idx === activeTab;
            return (
              <button
                key={tab.title}
                id={`admin-tab-${tab.title}`}
                type="button"
                role="tab"
                aria-selected={isActive}
                aria-controls={`admin-panel-${tab.title}`}
                tabIndex={isActive ? 0 : -1}
                onClick={() => setActiveTab(idx)}
                className={[
                  "group inline-flex items-center gap-2 rounded-full px-3 py-2 text-[11px] sm:text-sm font-semibold whitespace-nowrap transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-400 focus-visible:ring-offset-2",
                  isActive
                    ? "bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 text-white shadow-lg shadow-slate-500/30 ring-slate-900/70 scale-[1.02]"
                    : "text-slate-500 hover:text-slate-700 hover:bg-slate-50",
                ].join(" ")}
              >
                <span
                  className={[
                    "flex items-center justify-center h-6 w-6 rounded-full transition-colors",
                    isActive
                      ? "bg-white/15 text-white ring-1 ring-white/30"
                      : "bg-slate-100 text-slate-600 group-hover:bg-slate-200",
                  ].join(" ")}
                >
                  <Icon className="text-[12px] sm:text-[14px]" />
                </span>
                <span>{tab.title}</span>
              </button>
            );
          })}
        </div>
      </div>

      <div className="mt-3">
        {tabs[activeTab] && (
          <div
            id={`admin-panel-${tabs[activeTab].title}`}
            role="tabpanel"
            aria-labelledby={`admin-tab-${tabs[activeTab].title}`}
          >
            {tabs[activeTab].content}
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminPage;
